export default "__VITE_ASSET__D9hne4cI__"